module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Liverpool-8caa62acbd4a746728ddc7069f347b73.svg";